module.exports = __webpack_public_path__ + "img/content7-9.7207318f.webp";